import React, { Component, Fragment } from "react";
import moment from "moment";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Creators as ReportsActions,
  Selectors as ReportsSelectors,
} from "store/ducks/reports";

import { Access, NumberFormat } from "common";
import { Page, Breadcrumbs, Panel, Loading } from "components";
import { Filters } from "./components";

const FILTER_DEFAULT_VALUES = {
  formatted_stores: "Todas",
  date_formatted: "",
  date_start: null,
  date_end: null,
  discount: null,
  campaign: null,
  voucher_id: null,
  regions: [],
  channels: [],
};

class Benefits extends Component {
  state = {
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Relatórios", to: "/reports" },
      { name: "Relatório de Benefícios", to: "" },
    ],
    filter: {
      ...FILTER_DEFAULT_VALUES,
      stores: Access.lockedStore() ? [Access.lockedStore(true)] : [],
    },
    isFirstLoad: true,
    isInCooldown: false
  };

  // componentDidMount() {
  //   const { getReportBenefitsRequest } = this.props;

  //   getReportBenefitsRequest(this.state.filter);
  // }

  componentDidUpdate(oldProps, oldState) {
    const { filter } = this.state;

    if (
      oldState.filter.date_start !== filter.date_start ||
      oldState.filter.date_end !== filter.date_end
    ) {
      const date_formatted = filter.date_start
        ? `${
            filter.date_start !== null
              ? moment(filter.date_start).format("DD/MM/YYYY")
              : ""
          } ${filter.date_end !== null ? "-" : ""} ${
            filter.date_end !== null
              ? moment(filter.date_end).format("DD/MM/YYYY")
              : ""
          }`
        : "";

      this.setState({ filter: { ...filter, date_formatted } });
    }

    if (oldState.filter.stores !== filter.stores) {
      const formattedStores = filter.stores
        .map((store) => `${store.label}`)
        .join(", ");

      this.setState({
        filter: { ...filter, formatted_stores: formattedStores || "Todas" },
      });
    }
  }

  handleChangeFilter = (name, value) => {
    const { filter } = this.state;

    this.setState({ filter: { ...filter, [name]: value } });
  };

  handleCleanFilter = (e) => {
    e.preventDefault();

    // const { getReportBenefitsRequest } = this.props;

    const defaultFilters = {
      filter: {
        ...FILTER_DEFAULT_VALUES,
        stores: Access.lockedStore() ? [Access.lockedStore(true)] : [],
      },
    };

    this.setState(defaultFilters/*, () => {
      getReportBenefitsRequest(this.state.filter);
    }*/);
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (this.state.isInCooldown) {
      return;
    }

    if (this.state.isFirstLoad) {
      this.setState({ isFirstLoad: false });
    }

    this.setState({ isInCooldown: true })

    setTimeout(() => {
      this.setState({
        isInCooldown: false
      });
    }, 1000);

    const { getReportBenefitsRequest } = this.props;

    getReportBenefitsRequest(this.state.filter);
  };

  handleExport = () => {
    const { filter } = this.state;
    const { exportReportBenefitRequest } = this.props;

    exportReportBenefitRequest(filter);
  };

  render() {
    const { breadcrumbs, filter, isFirstLoad } = this.state;
    const { report } = this.props;

    return (
      <Page className="page-reports">
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <header className="page-reports-header">
          <Page.Title>Relatório de Benefícios</Page.Title>

          <Filters
            data={filter}
            disabled={isFirstLoad ? false : report.loading}
            onChange={this.handleChangeFilter}
            onClean={this.handleCleanFilter}
            onSubmit={this.handleSubmit}
          />
        </header>

        <Panel className="panel-list">
          <Fragment>
            {!isFirstLoad && report.loading && <Loading type="table" size="x-large" />}

            {filter.date_formatted !== "" && (
              <Panel.Title>
                Período: <span>{filter.date_formatted}</span>
              </Panel.Title>
            )}

            {filter.formatted_stores !== "" && (
              <Panel.Title>
                Lojas: <span>{filter.formatted_stores}</span>
              </Panel.Title>
            )}

            <h5>Relatório de Benefício (Voucher de desconto)</h5>

            <table className="contact-table table table-curved">
              <thead>
                <tr>
                  <th>Benefícios</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>Benefícios resgatados</td>
                  <td className="number-report">
                    {report.data.reedem_benefits}
                  </td>
                </tr>
                <tr>
                  <td>Benefícios utilizados</td>
                  <td className="number-report">{NumberFormat(report.data.used_benefits || 0 , 0, ',', '.')}</td>
                </tr>

                <tr>
                  <td>Taxa de benefícios convertidos</td>
                  <td className="number-report">{ `${NumberFormat((report.data.benefits_conversion * 100) || 0, 0, ',', '.')}`} %</td>
                </tr>
              </tbody>

              <thead>
                <tr>
                  <th>Ticket médio e descontos</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Ticket médio em compras com benefícios</td>
                  <td className="number-report">
                    R$ {report.data.average_ticket}
                  </td>
                </tr>
                <tr>
                  <td>Desconto médio em compras com benefícios </td>
                  <td className="number-report">
                    {report.data.average_discount}
                  </td>
                </tr>
                <tr>
                  <td>Valor total em compras com benefícios </td>
                  <td className="number-report">
                    R$ {report.data.total_value_with_benefits}
                  </td>
                </tr>
              </tbody>
            </table>

            <button
              type="button"
              className="button-submit"
              onClick={this.handleExport}
            >
              Exportar Planilha
            </button>
          </Fragment>
        </Panel>
      </Page>
    );
  }
}

const mapState = (state) => ({
  report: {
    ...state.reports.benefits,
    data: ReportsSelectors.benefits(state.reports.benefit.data),
    loading: state.reports.benefit.loading,
  },
});

const mapActions = (dispatch) => bindActionCreators(ReportsActions, dispatch);

export default connect(mapState, mapActions)(Benefits);
